import type { PartialDeep } from 'type-fest'
import type { FormContext } from 'vee-validate'
import { email } from '@solfacil/frontend-utils'
import * as z from 'zod'

type Translate = (key: string) => string

export function getSchema(t: Translate, options?: { isPartner?: boolean }) {
  const isPartner = options?.isPartner ?? true
  const supplierEmailSchema = z.array(
    z.string().refine(
      e => !e || email.validInput(e),
      { message: t('receipt-model.billing_letter.errors.invalid_email') },
    ),
  )
  return z.object({
    hardware_supplier: z.object({
      name: z.string().optional(),
      value: z.number().min(1, { message: t('form.required') }),
    }),
    equipment_value: z.number().min(1, { message: t('form.required') }),
    supplier_email: isPartner ? supplierEmailSchema : supplierEmailSchema.optional(),
  })
}

export type FormSchema = z.infer<ReturnType<typeof getSchema>>
export type Form = FormContext<PartialDeep<FormSchema>>
export type Field = keyof(FormSchema)

export function getInitialValues(): Partial<FormSchema> {
  return {
    hardware_supplier: {
      name: '',
      value: 0,
    },
    equipment_value: 0,
    supplier_email: [],
  }
}
